import type { GetterClass, ToolingState } from '../../../models'

export class PaginationGetter implements GetterClass {
  static execute(this: void, state: ToolingState): ToolingState['pagination'] {
    return state.pagination
  }
}
